import { format } from "date-fns";
import {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { extractVideoId, sanitizeText } from "../newComponents/GeneralClasses";
import { AuthContext } from "../AuthContext";
import { ref, set } from "firebase/database";
import { realTimeDB } from "../firebase";
import tvaxiosapi from "../api/tvaxiosapi";
import { Timestamp } from "firebase/firestore";
import { ConstVariables } from "./ConstantVariables";

const Tvscheduleform = ({
  getLastTime,
  handleCancel,
  id,
  handleUpdateFetch,
}) => {
  const [videoLink, setVideoLink] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [videoThumbNail, setVideoThumbnail] = useState("");
  const [isYoutubeLink, setIsYoutubeLink] = useState(false);
  const [parsingLink, setParsingLink] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [showPicker, setShowPicker] = useState(false);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  // const [vidDuration,setVidDuration]=useState("");
  const [videoEndTime, setEndTime] = useState(0);
  const [state, dispatch] = useReducer(reducer, {
    alertMessage: "",
    showAlert: false,
    progressIndicator: false,
  });
  const { uid, user_email } = useContext(AuthContext);
  const datePickerRef = useRef(null);
  const now = Timestamp.now();
  const todayDate = format(now.toDate(), "yyyy-MM-dd");

  const handleGetStartTime = useCallback(() => {
    if (getLastTime && id > 1) {
      setStartTime(getLastTime);
    } else {
      setStartTime(Date.now());
    }
  }, [getLastTime, id]);

  useEffect(() => {
    handleGetStartTime();
  }, [handleGetStartTime]);

  const formatStartTime = () => {
    try {
      const formattedTime = format(new Date(startTime), "hh:mm:ss a");
      return formattedTime;
    } catch {}
  };

  const handleDateChange = (event) => {
    const date = new Date(event.target.value);
    setStartTime(date.getTime());
  };

  useEffect(() => {
    const handleClosePicker = (e) => {
      if (showPicker) {
        if (!datePickerRef.current.contains(e.target)) {
          setShowPicker(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClosePicker);
    return () => document.removeEventListener("mousedown", handleClosePicker);
  }, [showPicker]);

  const duration = useCallback(
    () =>
      Number(hours * 3600 * 1000) +
      Number(minutes * 60 * 1000) +
      Number(seconds * 1000),
    [hours, minutes, seconds]
  );

  const CalculateEndTime = useCallback(() => {
    let getVideoEndTime = Number(startTime) + duration();
    setEndTime(getVideoEndTime);
  }, [startTime, duration]);

  useEffect(() => {
    CalculateEndTime();
  }, [CalculateEndTime]);

  const handlePublish = async () => {
    try {
      if (
        (hours && (hours < 0 || hours > 24)) ||
        (minutes && (minutes < 0 || minutes > 60)) ||
        (seconds && (seconds < 0 || seconds > 60))
      ) {
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: "invalid time input. Check the video duration you entered.",
        });
        return;
      }
      if (videoLink === "" || videoTitle === "") {
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: "video link field should not be empty.",
        });
        return;
      }

      dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: true });
      const videodata = {
        videoLink,
        videoTitle,
        videoThumbNail,
        startTime,
        videoEndTime,
        vidDuration: `${hours > 0 ? hours + ":" : ""}${
          minutes >= 0 ? minutes + ":" : ""
        }${seconds >= 0 ? seconds : ""}`,
        userid: uid,
        useremail: user_email,
        api_key: ConstVariables.WEB_BOOKS_API_KEY,
      };

      try {
        const res = await tvaxiosapi.post(
          "/tvshows/uploadvideo",
          JSON.stringify(videodata),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: false,
          }
        );
        dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: false });
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: res?.data?.success,
        });
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        handleUpdateFetch();
        handlePublishToFirebase(videoTitle);
        sessionStorage.setItem(`videoendtime`, videoEndTime);
      } catch (error) {
        dispatch({ type: actionConsts.SHOWALERT, payload: true });
        if (!error?.response) {
          dispatch({
            type: actionConsts.ALERT_MESSAGE,
            payload: `schedule ${id} failed to publish❌. Try consulting the support team to fix this issue`,
          });
        } else if (error?.response) {
          dispatch({
            type: actionConsts.ALERT_MESSAGE,
            payload: error?.response?.data?.message,
          });
        }
      } finally {
        dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: false });
      }

      sessionStorage.setItem(`videoendtime`, videoEndTime);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePublishToFirebase = (video_Title) => {
    const childKey = sanitizeText(video_Title);
    if (childKey !== "") {
      set(ref(realTimeDB, `TvShows/${childKey}`), {
        videoUrl: videoLink,
        videoTitle,
        videoThumbNail,
        startTime,
        endTime: videoEndTime,
        date: todayDate,
        duration: `${hours > 0 ? hours + ":" : ""}${
          minutes >= 0 ? minutes + ":" : ""
        }${seconds >= 0 ? seconds : ""}`,
      });
    }
  };

  const handleCloseAlert = () => {
    dispatch({ type: actionConsts.SHOWALERT, payload: false });
  };

  const handleGetVideoTitle = (videourl) => {
    setParsingLink(true);
    const apiKey = process.env.REACT_APP_YOUTUBE_API_KEY;
    fetch(
      `https://www.googleapis.com/youtube/v3/videos?id=${extractVideoId(
        videourl
      )}&key=${apiKey}&part=snippet`
    )
      .then((response) => response.json())
      .then((data) => {
        const title = data.items[0].snippet.title;
        const thumbnail = data.items[0].snippet.thumbnails.high.url;
        setVideoTitle(title);
        setVideoThumbnail(thumbnail);
        setParsingLink(false);
      })
      .catch((err) => {
        setParsingLink(false);
        setIsYoutubeLink(false);
      });
  };

  const handleOnLinkPasted = (e) => {
    try {
      setTimeout(() => {
        const url = new URL(e.target.value);
        if (
          ["www.youtube.com", "youtube.com", "youtu.be"].includes(url.hostname)
        ) {
          setIsYoutubeLink(true);
        } else {
          setIsYoutubeLink(false);
          dispatch({
            type: actionConsts.ALERT_MESSAGE,
            payload: `schedule ${id} video link is not supported or the link is not valid url`,
          });
          dispatch({ type: actionConsts.SHOWALERT, payload: true });
        }
      }, 0);
    } catch {}
  };

  return (
    <div
      className="tvscheduleform flex-column1"
      style={{
        width: "80%",
        gap: "10px",
        backgroundColor: "#1C1F2E",
        borderRadius: "10px",
        padding: "5px",
        marginBottom: "20px",
        marginTop: "10px",
        boxShadow:
          "0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)",
        position: "relative",
      }}
    >
      {state.showAlert && (
        <CustomAlertDialog
          alertmessage={state.alertMessage}
          handleCloseDialog={handleCloseAlert}
          performAction={false}
        />
      )}
      {state.progressIndicator && (
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "45%",
            width: "50px",
            height: "50px",
            border: "5px solid white",
            borderTop: "5px solid green",
            borderRadius: "50%",
            animation: "spin2 2s linear infinite",
          }}
        ></div>
      )}
      {parsingLink && (
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "45%",
            width: "50px",
            height: "50px",
            border: "5px solid transparent",
            borderTop: "5px solid white",
            borderRadius: "50%",
            animation: "spin2 2s linear infinite",
          }}
        ></div>
      )}
      <h4 style={{ color: "white" }}>{`Schedule ${id}`}</h4>
      <fieldset>
        <legend>Video Link</legend>
        <input
          type="text"
          placeholder="paste video Link"
          required
          value={videoLink}
          onPaste={handleOnLinkPasted}
          onChange={(e) => setVideoLink(e.target.value)}
        />
      </fieldset>
      {isYoutubeLink && (
        <button
          onClick={() => handleGetVideoTitle(videoLink)}
          style={{
            border: "none",
            borderRadius: "10px",
            color: "black",
            backgroundColor: "white",
            fontWeight: "bold",
          }}
        >
          Get details
        </button>
      )}
      <br />
      <fieldset>
        <legend>Video Title</legend>
        <input
          type="text"
          placeholder="write or paste title here"
          required
          value={videoTitle}
          onChange={(e) => setVideoTitle(e.target.value)}
        />
      </fieldset>
      {!isYoutubeLink && (
        <fieldset>
          <legend>Video Thumbnail</legend>
          <input
            type="text"
            placeholder="paste thumbnail link here"
            required
            value={videoTitle}
            onChange={(e) => setVideoTitle(e.target.value)}
          />
        </fieldset>
      )}
      {videoThumbNail !== "" && (
        <img
          src={videoThumbNail}
          alt=""
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      )}
      <br />
      <h4 style={{ color: "white" }}>Video duration</h4>
      <div className="flex-row2">
        <fieldset>
          <legend>hours</legend>
          <input
            type="number"
            required
            min={0}
            max={24}
            value={hours}
            onChange={(e) => setHours(e.target.value)}
          />
        </fieldset>

        <fieldset>
          <legend>minutes</legend>
          <input
            type="number"
            required
            min={0}
            max={60}
            value={minutes}
            onChange={(e) => setMinutes(e.target.value)}
          />
        </fieldset>

        <fieldset>
          <legend>seconds</legend>
          <input
            type="number"
            required
            min={0}
            max={60}
            value={seconds}
            onChange={(e) => setSeconds(e.target.value)}
          />
        </fieldset>
      </div>{" "}
      <br />
      <h4 style={{ color: "white" }}>Video runtime</h4>
      <fieldset>
        <legend>start time</legend>
        <div className="flex-column1">
          {/* <p style={{color:"white",fontWeight:"bold"}}>{format(new Date(startTime),"hh:mm:ss a")}</p> */}
          <p style={{ color: "white", fontWeight: "bold" }}>
            {formatStartTime()}
          </p>
          <input
            type="text"
            placeholder="video start time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          />
          <button onClick={() => setShowPicker(true)}>Change Time</button>
          {showPicker && (
            <input
              ref={datePickerRef}
              type="datetime-local"
              onChange={handleDateChange}
              min={new Date().toISOString().substring(0, 16)}
              style={{ backgroundColor: "whitesmoke", color: "black" }}
            />
          )}
        </div>
      </fieldset>
      <fieldset>
        <legend>End Time</legend>
        <div className="flex-column1">
          <p style={{ color: "white", fontWeight: "bold" }}>
            {format(new Date(videoEndTime), "hh:mm:ss a")}
          </p>
          <input
            type="text"
            placeholder="video end time"
            value={videoEndTime}
            onChange={(e) => setEndTime(e.target.value)}
          />
        </div>
      </fieldset>
      <div className="flex-row2" style={{ gap: "10px" }}>
        <button
          onClick={() => handlePublish()}
          style={{
            border: "none",
            backgroundColor: "green",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bolder",
            cursor: "pointer",
            padding: "10px",
          }}
        >
          Publish
        </button>

        <button
          onClick={handleCancel}
          style={{
            border: "none",
            backgroundColor: "red",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bold",
            cursor: "pointer",
            padding: "10px",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
export default Tvscheduleform;
